import request from '#/utils/request';
import { keysToCamel, normalizeListPage } from '#/api/adapters/wireCase';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * GET /srm/purchase-order/{poId}/arrival-schedules
 *
 * 後端可能回傳無 page 的 list；若 page 缺失則以空物件正規化。
 */
export async function fetchPurchaseOrderArrivalScheduleList(poId, listQuery) {
  const { data: raw } = await request.get(
    `/srm/purchase-order/${poId}/arrival-schedules`,
    { params: listQueryToApiParams(listQuery) },
  );
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.list ?? []),
    page: normalizeListPage(raw.page ?? {}),
  };
}
